import React from 'react';
import PropTypes from 'prop-types';

import { sizedImageShape } from '../../../types';

const LazyLoadImg = ({ alt, className, id, src, style }) => {
  const placeholderStyles = {
    maxWidth: '100%',
    height: 'auto'
  };

  return (
    <img
      alt={alt}
      className={className}
      id={id}
      src={src.url}
      style={{ ...style, ...placeholderStyles }}
      height={src.height}
      width={src.width}
      loading="lazy"
    />
  );
};

LazyLoadImg.defaultProps = {
  alt: '',
  className: undefined,
  id: undefined,
  style: undefined
};

LazyLoadImg.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: sizedImageShape.isRequired,
  style: PropTypes.string
};

export default LazyLoadImg;
